import './bottom.scss';
import sleep from 'utilities/sleep';
import animateCSS from 'utilities/animatecss';
class MessagesBottom {
  container: HTMLDivElement;
  children: Message[] = [];
  id: string = 'messages-bottom-container';
  constructor(){}
  add(content: string, klass = 'success'){
    this.genContainer();
    const message = new Message(content, klass);
    this.container.appendChild(message.element)
    message.show()
    // (async () => {
    //   await message.show()
    //   message.clear()
    // })()
  }
  genContainer(){
    this.container = document.getElementById(this.id) as HTMLDivElement;
    if(this.container){ return }
    this.container = document.createElement('div');
    this.container.setAttribute('id', this.id)
    document.body.appendChild(this.container);
  }
}

class Message {
  content: string;
  klass: string;
  animateIn: string;
  animateOut: string;
  element: HTMLDivElement;
  stayTime: number = 3000;
  constructor(
    content: string,
    klass: string = 'success',
    animateIn: string = 'fadeInUpBig',
    animateOut: string = 'fadeOut',
  ){
    this.content = content;
    this.klass = klass;
    this.animateIn = animateIn;
    this.animateOut = animateOut;
    this.gen();
  }
  gen(){
    this.element = document.createElement('div')
    this.element.classList.add('message');
    this.element.innerHTML = this.html();
  }
  show(){
    (async () => {
      await animateCSS(this.element, this.animateIn)
      await sleep(this.stayTime)
      await animateCSS(this.element, this.animateOut);
      this.clear()
    })()
  }
  html(){
    return `
      <div class="alert alert-${ this.klass }">${ this.content }</div>
    `
  }
  clear(){
    this.element.parentNode.removeChild(this.element);
  }
}

if(!window['MessagesBottom']){
  window['MessagesBottom'] = new MessagesBottom()
}

// $(document).on('turbolinks:load', function () {
//   window['MessagesBottom'].add('testtest1');
//   setTimeout(() => {
//     window['MessagesBottom'].add('testtest2');
//     window['MessagesBottom'].add('testtest3');
//   }, 1000)
// });
